
import useAxiosPrivate from ".././useAxiosPrivate";
import { toast } from "react-toastify";
const useAddDemoDeliveryBoy = () => {
  // console.log(form);
  const Axios = useAxiosPrivate();

  const addDeliveryBoy = async (param, areaData) => {
    param.shape_id = areaData?.selectedShapeId
    const response = await Axios.post("/add_demo_delivery_boy", param);
    const data = await response.data;
    if (data.status === 200) {
      toast.success(data.message);
    } else if (data.status === 400) {
      toast.error(data.message);
    } else {
      toast.error("Failed to Add");
    }
  };
  return addDeliveryBoy;
};

export default useAddDemoDeliveryBoy;
